import useStyle from './forgotContent.style';
import { ExternalLink } from 'components/atoms/Links/ExternalLink';
import { LabelWithoutBG } from 'components/atoms/Label/Label.stories';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { TextInput } from 'components/atoms/Inputs/TextInput';
import React, { useState } from 'react';
import { passwordForgotten } from '../../../../REST/password/forgotten';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dispatch } from 'redux';
import { History, LocationState } from 'history';
import pages from 'routes/pages';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import toast from 'react-hot-toast';

export const ForgotContent = () => {
  const [loading, setLoading] = useState(false);
  const renewMail = async (
    email: string,
    dispatch: Dispatch,
    history: History<LocationState>
  ) => {
    try {
      setLoading(true);
      const res = await passwordForgotten(email);
      if (res.success) toast.success(res.message);
      if (res.error) toast.error(res.message);
      setLoading(false);
    } catch (err) {
      console.error(err);
    }
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [email, setEmail] = useState(null);
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>
        Demande de renouvellement de mot de passe
      </h1>
      <p>
        Veuillez renseigner votre mail et vous recevrez la marche à suivre dans
        votre boite de réception.
      </p>
      <div className={classes.formContainer}>
        <FeatureContainer>
          <div className={classes.form}>
            <LabelWithoutBG text="Votre mail" />
            <TextInput
              name="email"
              type="email"
              onChange={event => setEmail(event.target.value)}
              value={email || ''}
              placeHolder="ex: test@gmail.com..."
              requiredValue={true}
            />
          </div>

          <div className={classes.buttons}>
            <ButtonWithText
              content="Envoyer"
              onClick={() => renewMail(email, dispatch, history)}
              disabled={!email}
              loading={loading}
            />
          </div>
        </FeatureContainer>
      </div>

      <ExternalLink
        variant="helpLanding"
        textInside="Revenir à l'écran de connexion"
        link={pages.SIGN_IN.path}
        isOpenNewTab={false}
      />
    </div>
  );
};
